import * as yup from 'yup'

import { isValidCnpj, isValidCpf } from './documentValidator'
import { getMessage } from './IntlMessages'

export function numberNullAble(typeError) {
  if (typeError !== null) {
    return yup.number().typeError(getMessage(typeError)).nullable()
  }

  return yup.string().nullable()
}

export function numberNotNullable(typeError) {
  if (typeError !== null) {
    return yup
      .number()
      .typeError(getMessage(typeError))
      .required(getMessage('isRequired', getMessage('documentNumber')))
  }

  return yup.string().required()
}

export function numberPositive(typeError) {
  return yup.number().positive().typeError(getMessage(typeError))
}

export function arrayLength() {
  return yup
    .array()
    .min(1, 'tipo')
    .required(getMessage('isRequired', getMessage('Tipo')))
}

export function stringRequired(propName, max, typeError = null, min = null) {
  const minValue = min ? min : 0
  const maxValue = max ? max : 999999
  const typeErrorValue = typeError ? getMessage(typeError) : null
  const propNameValue = propName ? getMessage('isRequired', propName) : null

  return yup
    .string()
    .required(propNameValue)
    .min(minValue, getMessage('minLenght', propName, minValue))
    .max(maxValue, getMessage('maxLenght', propName, maxValue))
    .typeError(typeErrorValue)
}

export function documentTypeValidation(propName, max, typeError) {
  return yup
    .string()
    .max(max)
    .required(getMessage('isRequired', getMessage(propName)))
    .typeError(getMessage(typeError))
    .when('documentType', (documentType, schema) => {
      if (documentType === 'CPF') {
        return schema.test('documentNumber', getMessage('cpfInvalid'), (value) => {
          const isValid = isValidCpf(value)
          return isValid
        })
      }

      if (documentType === 'CNPJ') {
        return schema.test('documentNumber', getMessage('cnpjInvalid'), (value) => {
          const isValid = isValidCnpj(value)
          return isValid
        })
      }

      return schema
    })
}
